import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=a0125f82&scoped=true"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=js"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordSuccess.vue?vue&type=style&index=0&id=a0125f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0125f82",
  null
  
)

export default component.exports